import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { NC_MANUAL_PATH, SCT_MANUAL_PATH } from "../constants";
import { ApplicationService } from "../services/application.service";
import { EvPdfViewerComponent } from "./ev-pdf-viewer.component";

@Component({
    selector: 'app-manuale',
    styles: [`
        .container {
            position: relative;
            height: 90vh;
        }
    `],
    template: `
    <div class="container">
        <h1>Manuale di {{applicationName}}</h1>
        <ev-pdf-viewer [src]="manualPath"></ev-pdf-viewer>
    </div>
`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [EvPdfViewerComponent]
})
export class EvManualeComponent {
    private applicationService = inject(ApplicationService);

    applicationName: string
    manualPath: string

    constructor() {
        this.applicationName = this.applicationService.getApplicationName()

        if (this.applicationService.isNextComunica()) {
            this.manualPath = NC_MANUAL_PATH
        } else {
            this.manualPath = SCT_MANUAL_PATH
        }
    }

}
